<template>
  <div class="page-content address-invoice-page">
    <div class="container invoice-address-container">
      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="container">
            <div
              class="text-center d-flex justify-content-center align-items-center mb-4 pb-3 gap-3"
            >
              <a @click="$router.go(-1)" class="cursor-pointer">
                <svg
                  width="12"
                  height="16"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.40059 10.7993L1.60059 5.99932L6.40059 1.19932"
                    stroke="#001D21"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <h1 class="page-title mb-0">Invoice Detail</h1>
            </div>
            <a class="refresh" v-on:click="getInvoiceAddress()">
              <svg
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.25 14.2617C14.0511 14.2617 13.8603 14.1827 13.7197 14.042C13.579 13.9014 13.5 13.7106 13.5 13.5117V10.5117H10.5C10.3011 10.5117 10.1103 10.4327 9.96967 10.292C9.82902 10.1514 9.75 9.96063 9.75 9.76172C9.75 9.56281 9.82902 9.37204 9.96967 9.23139C10.1103 9.09074 10.3011 9.01172 10.5 9.01172H14.25C14.4489 9.01172 14.6397 9.09074 14.7803 9.23139C14.921 9.37204 15 9.56281 15 9.76172V13.5117C15 13.7106 14.921 13.9014 14.7803 14.042C14.6397 14.1827 14.4489 14.2617 14.25 14.2617ZM4.5 6.01172H0.75C0.551088 6.01172 0.360322 5.9327 0.21967 5.79205C0.0790176 5.6514 0 5.46063 0 5.26172V1.51172C0 1.31281 0.0790176 1.12204 0.21967 0.981389C0.360322 0.840736 0.551088 0.761719 0.75 0.761719C0.948912 0.761719 1.13968 0.840736 1.28033 0.981389C1.42098 1.12204 1.5 1.31281 1.5 1.51172V4.51172H4.5C4.69891 4.51172 4.88968 4.59074 5.03033 4.73139C5.17098 4.87204 5.25 5.06281 5.25 5.26172C5.25 5.46063 5.17098 5.6514 5.03033 5.79205C4.88968 5.9327 4.69891 6.01172 4.5 6.01172Z"
                  fill="#0E8090"
                />
                <path
                  d="M7.50005 15.0116C5.65484 15.0119 3.87427 14.332 2.49889 13.1019C1.12352 11.8718 0.249869 10.1779 0.0450512 8.34409C0.0342172 8.2456 0.0428886 8.14594 0.0705703 8.0508C0.098252 7.95566 0.144402 7.86691 0.206385 7.7896C0.331565 7.63348 0.513639 7.53348 0.712551 7.5116C0.911464 7.48971 1.11092 7.54775 1.26705 7.67293C1.42317 7.79811 1.52317 7.98018 1.54505 8.1791C1.6933 9.53112 2.29651 10.7927 3.2558 11.7569C4.21509 12.7211 5.47352 13.3308 6.82477 13.486C8.17602 13.6411 9.5399 13.3326 10.6928 12.6109C11.8457 11.8893 12.7192 10.7973 13.1701 9.5141C13.1982 9.41545 13.2462 9.32362 13.3112 9.24429C13.3763 9.16496 13.4569 9.0998 13.5481 9.05286C13.6393 9.00591 13.6587 9.02004 13.761 9.01322C14.03 9.01322 13.761 9.01322 14.1523 9.01322C14.2489 9.04765 14.3282 9.10154 14.4032 9.17155C14.4782 9.24156 14.538 9.3262 14.5789 9.42025C14.6199 9.51429 14.6411 9.61573 14.6413 9.7183C14.6415 9.82088 14.6207 9.9224 14.5801 10.0166C14.0617 11.4794 13.1024 12.7453 11.8343 13.6399C10.5663 14.5346 9.05193 15.0138 7.50005 15.0116ZM14.2051 7.5116C14.0196 7.51272 13.8404 7.44512 13.7019 7.32186C13.5634 7.19859 13.4754 7.02838 13.4551 6.84409C13.3002 5.49854 12.6946 4.24498 11.7368 3.2873C10.779 2.32962 9.52538 1.72418 8.17981 1.56946C6.83424 1.41473 5.47591 1.71983 4.32575 2.43512C3.17559 3.15041 2.30129 4.23381 1.84505 5.5091C1.81693 5.60774 1.76888 5.69957 1.70386 5.7789C1.63884 5.85823 1.55824 5.92339 1.46704 5.97033C1.37584 6.01728 1.25627 6.00315 1.15392 6.00997C1.05158 6.01679 1.04029 6.00997 0.801657 6.00997C0.705036 5.97554 0.686855 5.92165 0.611888 5.85164C0.536921 5.78163 0.477112 5.69699 0.436157 5.60294C0.395203 5.5089 0.373974 5.40746 0.373784 5.30488C0.373594 5.20231 0.394446 5.10079 0.435051 5.0066C0.999747 3.40465 2.09149 2.04183 3.53161 1.14118C4.97173 0.240523 6.67492 -0.144617 8.36243 0.0487899C10.0499 0.242196 11.6218 1.00269 12.8208 2.20582C14.0198 3.40894 14.7749 4.98343 14.9626 6.67159C14.9836 6.86837 14.9261 7.0655 14.8025 7.22003C14.6788 7.37457 14.4992 7.47397 14.3026 7.49659L14.2051 7.5116Z"
                  fill="#0E8090"
                />
              </svg>

              Refresh Details
            </a>
            <h2>Select business name for invoice</h2>
            <div class="note mb-3" style="display: flex; gap: 5px">
              <span>
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z"
                    fill="#808493"
                  />
                  <path
                    d="M5 2.40039V5.40039"
                    stroke="white"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5 7.60059C5.27614 7.60059 5.5 7.37673 5.5 7.10059C5.5 6.82444 5.27614 6.60059 5 6.60059C4.72386 6.60059 4.5 6.82444 4.5 7.10059C4.5 7.37673 4.72386 7.60059 5 7.60059Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span>
                Note: The selected name will be displayed on all invoices created for this
                outlet via the application
              </span>
            </div>
            <div class="card" v-on:click="setName(legal_name)">
              <div class="item">
                <div>
                  <span class="label">Legal Name</span>
                  <div class="card-text">{{ legal_name }}</div>
                </div>

                <svg
                  v-if="legal_name == selected_legal_name"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="9" cy="9" r="8.5" fill="white" stroke="#B0D0D4" />
                  <circle cx="9" cy="9" r="9" fill="#3DA437" />
                  <path
                    d="M5 9L7.66667 12L13 6"
                    stroke="white"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div
              class="card"
              v-if="legal_name != trade_name"
              v-on:click="setName(trade_name)"
            >
              <div class="item" style="display: block">
                <span class="label">Trade Name</span>
                <div class="card-text">{{ trade_name }}</div>
              </div>
            </div>
            <h2>Select address for invoice</h2>
            <div class="note mb-3" style="display: flex; gap: 5px">
              <span>
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10Z"
                    fill="#808493"
                  />
                  <path
                    d="M5 2.40039V5.40039"
                    stroke="white"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5 7.60059C5.27614 7.60059 5.5 7.37673 5.5 7.10059C5.5 6.82444 5.27614 6.60059 5 6.60059C4.72386 6.60059 4.5 6.82444 4.5 7.10059C4.5 7.37673 4.72386 7.60059 5 7.60059Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span>
                Note: The selected name will be displayed on all invoices created for this
                outlet via the application
              </span>
            </div>

            <p class="mb-3">Principal Address</p>
            <div class="card" v-on:click="setAddress(principal_address)">
              <div class="item">
                <div class="address">
                  <div>
                    <svg
                      width="16"
                      height="21"
                      viewBox="0 0 16 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.92308 19C7.92308 19 14.8462 12.7391 14.8462 8.04348C14.8462 4.15347 11.7466 1 7.92308 1C4.09957 1 1 4.15347 1 8.04348C1 12.7391 7.92308 19 7.92308 19Z"
                        fill="#DEE9EA"
                        stroke="#004852"
                        stroke-width="1.5"
                      />
                      <path
                        d="M10.6918 7.92353C10.6918 9.45293 9.45196 10.6928 7.92255 10.6928C6.39315 10.6928 5.15332 9.45293 5.15332 7.92353C5.15332 6.39412 6.39315 5.1543 7.92255 5.1543C9.45196 5.1543 10.6918 6.39412 10.6918 7.92353Z"
                        fill="white"
                        stroke="#004852"
                        stroke-width="1.5"
                      />
                    </svg>
                  </div>

                  <div class="address-details">
                    {{ principal_address }}
                  </div>
                </div>
                <div>
                  <svg
                    v-if="principal_address == selected_address"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="9" cy="9" r="8.5" fill="white" stroke="#B0D0D4" />
                    <circle cx="9" cy="9" r="9" fill="#3DA437" />
                    <path
                      d="M5 9L7.66667 12L13 6"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <p class="mb-3">Additional Address</p>
            <div
              style="
                height: 50vh;
                overflow-y: auto;
              "
            >
              <div
                class="card"
                v-for="item in tempPartnerList"
                :key="item.id"
                v-on:click="setAddress(item.address)"
              >
                <div class="item">
                  <div class="address">
                    <div>
                      <svg
                        width="16"
                        height="21"
                        viewBox="0 0 16 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.92308 19C7.92308 19 14.8462 12.7391 14.8462 8.04348C14.8462 4.15347 11.7466 1 7.92308 1C4.09957 1 1 4.15347 1 8.04348C1 12.7391 7.92308 19 7.92308 19Z"
                          fill="#DEE9EA"
                          stroke="#004852"
                          stroke-width="1.5"
                        />
                        <path
                          d="M10.6918 7.92353C10.6918 9.45293 9.45196 10.6928 7.92255 10.6928C6.39315 10.6928 5.15332 9.45293 5.15332 7.92353C5.15332 6.39412 6.39315 5.1543 7.92255 5.1543C9.45196 5.1543 10.6918 6.39412 10.6918 7.92353Z"
                          fill="white"
                          stroke="#004852"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>

                    <div class="address-details">
                      {{ item.address }}
                    </div>
                  </div>
                  <div>
                    <svg
                      v-if="item.address == selected_address"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="9" cy="9" r="8.5" fill="white" stroke="#B0D0D4" />
                      <circle cx="9" cy="9" r="9" fill="#3DA437" />
                      <path
                        d="M5 9L7.66667 12L13 6"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div style="display: flex; justify-content: end">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange"
                ref="listPagination"
              />
            </div>
          </div>

          <div class="text-center mt-4">
            <button
              id="save-profile"
              class="btn btn-primary px-5"
              v-on:click="saveAddress()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <ErrorComponent ref="errorComponent" />
    </div>
  </div>
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent.vue";
import Pagination from "@/components/Pagination.vue";
export default {
  name: "AccountNav",
  components: {
    ErrorComponent,
    Pagination,
  },

  data() {
    return {
      meData: {},
      tempPartnerList: [],
      workshop_id: "",
      legal_name: "",
      trade_name: "",
      principal_address: "",
      selected_legal_name: "",
      selected_address: "",
      offset: -1,
      currentPage: this.$store.getters.getCurrentPage
        ? this.$store.getters.getCurrentPage
        : 0,
    };
  },

  mounted() {
    this.getMeCall();
  },
  methods: {
    checkAddress(page) {
      this.$api
        .getAPI({
          _action: "get-invoice-detail/" + this.workshop_id,
          _body: { offset: page },
        })
        .then((res) => {
          this.tempPartnerList = res.additional_address_list;
          this.legal_name = res.legal_name;
          this.trade_name = res.trade_name;
          this.selected_address = res.selected_address;
          this.selected_legal_name = res.selected_legal_name;
          this.principal_address = res.principal_address;

          if (!this.selected_address) {
            this.selected_address = this.principal_address;
          }

          if (!this.selected_legal_name) {
            this.selected_legal_name = this.legal_name;
          }

          if (page >= 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
                this.$refs.listPagination.setCurrentPage(page + 1);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }

          if (this.tempPartnerList.length == 0) {
            if (this.$refs.errorComponent) {
              this.$refs.errorComponent.setTitle("No Data Available");
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.showLoader(false);
          }
          console.log(res);
        })
        .catch(() => {
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.showLoader(false);
          }
        });
    },
    pageChange(offset) {
      this.$store.commit("setCurrentPage", offset - 1);
      this.checkAddress(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.checkAddress(this.currentPage);
    },
    getInvoiceAddress() {
      this.$api
        .getAPI({
          _action: "get-invoice-address/" + this.workshop_id,
        })
        .then((res) => {
          console.log(res);
          this.checkAddress(this.currentPage);
        })
        .catch(() => {});
    },
    getMeCall() {
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.showLoader(true);
      }
      this.$api
        .getAPI({
          _action: "me",
        })
        .then((res) => {
          this.meData = res.result;
          this.workshop_id = res.result.workshop_id;
          this.address = this.meData.workshop.invoice_address;
          this.checkAddress(this.currentPage);
        })
        .catch(() => {
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.showLoader(false);
          }
        });
    },
    setAddress(address) {
      this.selected_address = address;
    },
    setName(legal_name) {
      this.selected_legal_name = legal_name;
    },
    saveAddress() {
      this.$api
        .postAPI({
          _action: "/set-invoice-detail/" + this.workshop_id,
          _buttonId: "save-profile",
          _body: { address: this.selected_address, legal_name: this.selected_legal_name },
        })
        .then((res) => {
          this.$toast.open({
            message: res.message,
            type: "success",
            duration: 3000,
            position: "top-right",
          });
          this.address = "";
          this.getMeCall();
        })
        .catch((error) => {
          console.error(error);
          this.$toast.open({
            message: "Error",
            type: "error",
            duration: 3000,
            position: "top-right",
          });
        });
    },
  },
};
</script>

